import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { People, TrendingUp, Star } from '@mui/icons-material';
import PremiumCard from '../components/ui/PremiumCard';
import CustomerSegmentationCard from '../components/Dashboard/cards/CustomerSegmentationCard';
import { useStoreStats } from '../hooks/useApiWithStore';

/**
 * Página de Segmentación de Clientes
 * Análisis RFM completo que Tiendanube no tiene
 */
export default function CustomerSegmentation() {
  const { data: statsData, isLoading, error } = useStoreStats();

  if (isLoading) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography>Cargando análisis de clientes...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Segmentación de Clientes
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Análisis RFM avanzado y segmentación inteligente de tu base de clientes
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
          <CustomerSegmentationCard statsData={statsData} />
        </Grid>
        
        <Grid item xs={12} lg={4}>
          <PremiumCard
            title="Próximamente"
            subtitle="Más análisis de clientes"
            icon={<Star />}
            color="info"
          >
            <Typography variant="body2" color="text.secondary">
              • Análisis de cohortes
              • Predicción de churn
              • Valor de vida del cliente
              • Segmentación por comportamiento
            </Typography>
          </PremiumCard>
        </Grid>
      </Grid>
    </Container>
  );
}
